import { matchRoutes, useLocation } from "react-router-dom";

const DRAWER_ROUTES = [
  { path: "/cards/:id" },
  { path: "/cards/:id/sudo/submit-otp" },
  { path: "/cards/:id/sudo/request-otp" },
  { path: "/cards/:id/travel_notice" },
  { path: "/cards/:id/limit_increase" },
  { path: "/cards/:id/limit_increase/sudo/submit-otp" },
  { path: "/cards/:id/limit_increase/sudo/request-otp" },
];

const useIsCardManagerDrawerOpen = () => {
  const location = useLocation();
  return (matchRoutes(DRAWER_ROUTES, location?.pathname) || []).length > 0;
};

export default useIsCardManagerDrawerOpen;
